import { getReviews, updateReview } from "../http/reviews.js";
import { initCommentsClass }  from "../comments.js";

export const personalReviews = (page, userID) => {
    const reviewsBlock = page.querySelector('.personal-office-reviews');

    if (!reviewsBlock) return;

    let reviewsObj = {
        reviews: []
    };

    let raitingValues = [1, 2, 3, 4, 5];

    const renderRaiting = (val) => {
        return `
            ${raitingValues.map((item) => {
                return  `
                    <svg class="icon-fluid">
                        <use xlink:href="/local/templates/taganrogotoplenie/dist/img/icons/icons.svg#icon-${item <= val ? 'fill-' : ''}star"></use>
                    </svg>
                `
            }).join('')}
        `
    }

    const renderRImages = (imgs) => {
        if (!imgs) {
            return '';
        }

        return `${
            imgs.map(item => {
                return `
                    <a data-fancybox="" href="${item}">
                        <img class="reviews-comment-img" src="${item}" alt="">
                        <svg class="icon-fluid">
                            <use xlink:href="/local/templates/taganrogotoplenie/dist/img/icons/icons.svg#icon-zoom_in"></use>
                        </svg>
                    </a>
                `
            }).join('')
        }`
    }

    const renderReviews = () => {
        if (reviewsObj.reviews.length < 1) {
            reviewsBlock.innerHTML = `<span>Вы ещё не оставляли отзывов</span>`;
            return;
        }

        reviewsBlock.innerHTML = `
            ${reviewsObj.reviews.map(item => {
                return `
                <div class="reviews-item item_catalog" data-reviews-id="${item.ID}">
                    <div class="reviews-item__header">
                        <div class="reviews-item__author-avatar">
                            <img class="avatar" src="/local/templates/taganrogotoplenie/img/user-icon.png" alt="">
                        </div>
                        <div class="reviews-item__info-column">
                            <div class="reviews-item__author-name">${item.NAME ? item.NAME : `Пользователь_${item.ID}`}</div>
                            <div class="reviews-item__date-public">${item.DATE_CREATE}</div>
                            <div class="reviews-item__raiting">
                                ${renderRaiting(item.RATING)}
                            </div>
                        </div>
                        <div class="reviews-item__managment">
                            <button data-reviews-id="${item.ID}" class="btn btn_link reviews-item__managment-item reviews-item__del">
                                удалить
                                <svg class="icon-fluid">
                                    <use xlink:href="/local/templates/taganrogotoplenie/dist/img/icons/icons.svg#icon-trash"></use>
                                </svg>
                            </button>
                            <button data-reviews-id="${item.ID}" class="btn btn_link reviews-item__managment-item reviews-item__edit">
                                редактировать рейтинг
                                <svg class="icon-fluid">
                                    <use xlink:href="/local/templates/taganrogotoplenie/dist/img/icons/icons.svg#icon-edit"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="reviews-item__desc reviews-item_elem">
                        <p class="reviews-item__desc-text desc-text-hide">${item.TEXT}</p>
                        <span class="reviews-item__desc-btn">Читать полностью</span>
                    </div>
                    <div class="reviews-item__product reviews-item_elem">
                        <div class="reviews-item__product-img">
                            <a data-fancybox="" href="${item.PRODUCT_PICTURE}">
                                <img class="product-img" src="${item.PRODUCT_PICTURE}" alt="${item.PRODUCT}">
                            </a>
                        </div>
                        <div class="reviews-item__product-info">
                                <span class="reviews-item__product-article">АРТИКУЛ: ${item.PRODUCT_ARTICLE ? item.PRODUCT_ARTICLE : 'осутствует'}</span>
                                <span class="reviews-item__product-name">${item.PRODUCT}</span>
                            </div>
                        </div>
                        <div class="reviews-item__images reviews-item_elem">
                            ${renderRImages(item.IMGS)}
                        </div>
                            
                        <div data-reviews-id="${item.ID}" data-user-id="${userID}" class="reviews-item__comments reviews-comments reviews-item_elem reviews-comments_open-comments">
                            <div class="reviews-comments__header">
                                <span class="reviews-comments__count">КОММЕНТАРИИ (${item.CNT_COMMENTS ? item.CNT_COMMENTS : '0'})</span>
                                <span class="reviews-comments__popup-switch">
                                    <svg class="icon-fluid">
                                        <use xlink:href="/local/templates/taganrogotoplenie/dist/img/icons/icons.svg#icon-rec-label"></use>
                                    </svg>
                                </span>
                            </div>
                            <div class="reviews-comments__new-comment new-comment">
                                <form class="new-comment__form">
                                    <div class="new-comment__avatar">
                                        <img src="/local/templates/taganrogotoplenie/img/user-icon.png" class="avatar" alt="">
                                    </div>
                                    <div class="new-comment__interaction">
                                        <div class="new-comment__header">
                                            Вы
                                            <div class="new-comment__close">
                                                <svg class="icon-fluid">
                                                    <use xlink:href="/local/templates/taganrogotoplenie/dist/img/icons/icons.svg#icon-close"></use>
                                                </svg>
                                            </div>
                                        </div>
                                        <div class="new-comment__input">
                                            <input type="text" maxlength="240" placeholder="Напишите комментарий"> 
                                            <span class="new-comment__public-rules">
                                                Перед отправкой комментария, пожалуйста, ознакомьтесь с <a href="#">правилами публикации</a> 
                                            </span>
                                        </div>
                                        <div class="new-comment__btn-send">
                                            <button class="btn btn_regular btn_info" type="button">ОТПРАВИТЬ</button>
                                        </div>
                                    </div>
                                </form>

                                <div class="new-comment__btn-add" data-toggle="modal" data-target="#review1">
                                    <button>+ Оставить комментарий</button>
                                </div>
                            </div>
                            <div class="reviews-comments__body">
                            </div>
                    </div>
                </div>
                `
            }).join('')}
        `
    }

    const handleShowModal = (isShow, modal) => {
        modal.style.display = isShow ? 'block' : 'none';
    }

    const editRaitingReview = async (id, raiting) => {
        const review = reviewsObj.reviews.find(item => item.ID == id);
        review.RATING = raiting;
    }

    const raitingRewrite = (id, raiting) => {
        const reviewItem = Array.from(reviewsBlock.children).find(item => item.getAttribute('data-reviews-id') == id);

        const reviewBlock = reviewItem.querySelector('.reviews-item__raiting');
        reviewBlock.innerHTML = renderRaiting(raiting);

        editRaitingReview(id, raiting);
    }

    const raitingEdits = () => {
        const modal = page.querySelector('.modal_custom');
        const modalClose = modal.querySelector('.modal-btn__close');
        const modalSend = modal.querySelector('.btn_submit');

        const modalRaiting = Array.from(modal.querySelectorAll('input[type="radio"]')).reverse();

        const setRaiting = (val) => {
            modalRaiting.forEach((item, index) => {
                if (index + 1 == val) item.checked = true;
            })
        }

        const getRaiting = () => {
            const raitnig = modalRaiting.find(item => item.checked);
            return  { value:  raitnig.value, index: raitnig.getAttribute('data-raiting-index')};
        }

        const evEdits = () => {
            const itemsEdit = reviewsBlock.querySelectorAll('.reviews-item__edit');
            const itemsDel = reviewsBlock.querySelectorAll('.reviews-item__del');

            if (!itemsEdit) return;

            let reviewsID = null;

            Array.from(itemsEdit).forEach(item => {
                item.addEventListener('click', (ev) => {
                    reviewsID = item.getAttribute('data-reviews-id');
                    const review = reviewsObj.reviews.find(elem => elem.ID == reviewsID);
                    setRaiting(review.RATING);
                    handleShowModal(true, modal);
                })
            });

            Array.from(itemsDel).forEach(item => {
                item.addEventListener('click', () => {
                    const id = item.getAttribute('data-reviews-id');
                    console.log(id);
                })
            });

            modalClose.addEventListener('click', (ev) => {
                ev.preventDefault();

                handleShowModal(false, modal);
            });

            modalSend.addEventListener('click', (ev) => {
                ev.preventDefault();
                const raiting = getRaiting();

                updateReview({
                    'ID': reviewsID,
                    'RATING': raiting.index
                }).then(res => {
                    if (res.error) {
                        console.log(res.error_description);
                        return;
                    }

                    raitingRewrite(reviewsID, raiting.index);
                    handleShowModal(false, modal);
                });
            })
        }

        evEdits();
    }

    const init = () => {
        getReviews(userID).then(res => {
            if (res.result.error) {
                console.log(res.result.error_message);

            } else if (res.result.message) {
                reviewsObj.reviews = [];
            }
             else {
                reviewsObj.reviews = res.result;
            }
        })

        reviewsObj = new Proxy(reviewsObj, {
            get(target, prop) {
                return target[prop];
            },

            set(target, prop, val) {
                target[prop] = val;

                renderReviews();
                initCommentsClass(reviewsBlock);
                raitingEdits();

                return true;
            }
        });
    }

    init();
}